import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f4896e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-country-code"
};
const _hoisted_2 = {
  class: "section-header"
};
const _hoisted_3 = {
  class: "section-header-wrap"
};
const _hoisted_4 = {
  class: "section-search"
};
const _hoisted_5 = {
  class: "section-searchbar"
};
const _hoisted_6 = ["placeholder"];
const _hoisted_7 = {
  class: "section-body"
};
const _hoisted_8 = {
  key: 0,
  class: "section-index"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 1,
  class: "section-fixed-anchor"
};
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $data.show = $event),
    position: "bottom",
    "safe-area-inset-top": "",
    "safe-area-inset-bottom": "",
    style: {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      padding: '0',
      width: '100%',
      height: '85%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
      class: "back",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.handleCancel && $options.handleCancel(...args))
    }, [_createVNode(_component_svg_icon, {
      class: "icon-back",
      "icon-class": "close"
    })]), _createElementVNode("span", null, _toDisplayString($props.title), 1)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_svg_icon, {
      class: "section-searchbar-prefix",
      "icon-class": "search"
    }), _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "section-searchbar-input",
      ref: "searchInput",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.keyword = $event),
      placeholder: $options.contentPlaceholder,
      onFocusin: _cache[2] || (_cache[2] = (...args) => $options.handleFocus && $options.handleFocus(...args)),
      onClick: _cache[3] || (_cache[3] = (...args) => $options.handleFocus && $options.handleFocus(...args)),
      onChange: _cache[4] || (_cache[4] = (...args) => $options.handleKeywordChange && $options.handleKeywordChange(...args))
    }, null, 40, _hoisted_6), [[_vModelText, $data.keyword, void 0, {
      trim: true
    }]]), _createElementVNode("em", {
      class: "section-searchbar-delete",
      onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.handleDelete && $options.handleDelete(...args), ["stop"]))
    }, [$data.keyword ? (_openBlock(), _createBlock(_component_svg_icon, {
      key: 0,
      "icon-class": "delete-filling"
    })) : _createCommentVNode("", true)]), $data.inputMode === 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "section-searchbar-blur",
      onClick: _cache[6] || (_cache[6] = $event => $options.handleFocus())
    })) : _createCommentVNode("", true)]), $data.inputMode !== 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "section-search-cancel",
      onClick: _cache[7] || (_cache[7] = (...args) => $options.handleKeywordCancel && $options.handleKeywordCancel(...args))
    }, _toDisplayString(_ctx.$t('cfmoto.form.cancel')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [$data.inputMode === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.indexList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "section-index-item",
        onClick: $event => $options.handleScrollView(index),
        key: item
      }, _toDisplayString(item), 9, _hoisted_9);
    }), 128))])) : _createCommentVNode("", true), $data.activeAnchorIndex > -1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($options.indexList[$data.activeAnchorIndex]), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "section-ul",
      onScroll: _cache[8] || (_cache[8] = (...args) => $options.handleScroll && $options.handleScroll(...args))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.searchOptions, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: item.value
      }, [$data.inputMode === 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["section-ul-anchor", {
          active: index === $data.activeAnchorIndex
        }]),
        ref_for: true,
        ref: "anchors"
      }, _toDisplayString(item.value), 3)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, citem => {
        return _openBlock(), _createElementBlock("div", {
          class: "section-ul-label",
          key: citem.key,
          onClick: $event => $options.handleChange(citem, index)
        }, _toDisplayString(citem.label) + " " + _toDisplayString(citem.value), 9, _hoisted_11);
      }), 128))], 64);
    }), 128))], 32)])])]),
    _: 1
  }, 8, ["show"]);
}